import { defineStore } from 'pinia'
import { usersApi as api } from '@/api/endpoints/users'
import { commonGetters } from "@/stores/commonGetters.js";
import { fetchCachedList, invalidateList } from '@/queries/storeCache'

export const useUsersStore = defineStore('users', {
  getters: {
    ...commonGetters,
  },
  actions: {
    /**
     * Cached for "give me every user for a picker/dropdown" calls. Only a real `page`
     * marks a paginated (management-table) call that always hits the network fresh —
     * callers asking for "everything" use `{ take_all: true }` or a large flat
     * `{ per_page: 200 }` with no `page`, and both are cacheable. Components read the
     * same cache entry through `useAllUsers` / `useUserPicker` (`@/queries/users`).
     * Pass `refresh: true` to force a refetch.
     */
    async GetAllUsers(params = {}, refresh = false) {
      return fetchCachedList('users', this.workspace_id, params, async () => {
        const body = await api.list(this.workspace_id, params)
        return body.data
      }, refresh)
    },

    /** Call after any create/update/delete/status-change to a workspace user so every
     * cached user list refetches (see `workspace.store.js`'s `CreateUser`/`UpdateUser`/
     * `DeleteUser`/`BulkUpdateUserStatus`, which call this on success). */
    invalidateUsersCache() {
      invalidateList('users')
    },
  },
})
